/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  mask: css`
    mask-type: alpha;
  `,
};

/**
 * Duplicated from `enterprise-admin-home/svg/ActionThumbnailBackground` rather than
 * imported — that bundle already depends on `enterprise-admin-learners` (for
 * `useInviteLearnersModal`), so importing the other way would create a cycle.
 */
const ActionThumbnailBackground = () => {
  // InviteSuccessDialog renders this component once per recommended action, so the mask
  // id must be unique per instance to avoid duplicate DOM ids breaking the mask reference.
  const maskId = `action-thumbnail-background-mask-${React.useId()}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={58} height={58} viewBox="0 0 58 58" fill="none" aria-hidden="true">
      <mask id={maskId} css={styles.mask} maskUnits="userSpaceOnUse" x="0" y="0" width="58" height="58">
        <rect width="58" height="58" rx="8" fill="var(--cds-color-emphasis-primary-background-xweak)" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M80.9881 43.9031L72.5333 74.4362C50.6467 68.5756 33.6045 51.6135 27.7793 29.8927C21.9541 8.17194 28.2231 -15.0364 44.2423 -31.0538L66.8426 -8.84192C58.8331 -0.833202 55.6986 10.771 58.6112 21.6313C61.5238 32.4917 70.0449 40.9727 80.9881 43.9031Z"
          fill="var(--cds-color-emphasis-primary-background-weak)"
        />
      </g>
    </svg>
  );
};

export default ActionThumbnailBackground;
